import type { LocationQueryValue } from 'vue-router';
import type { DialogNameType } from '#base/core/types/DialogNameType';

export const DIALOG_COOKIE = 'dialog-cookie';
export const DIALOG_APPOINTMENT = 'dialog-appointment';
export const DIALOG_CONTACT = 'dialog-contact';
export const DIALOG_MOBILE_MENU = 'dialog-mobile-menu';

const APPOINTMENT_QUERY = 'afspraak-inplannen';

const hideLogo = ref<boolean>(false);
const hideRegularCloseButton = ref<boolean>(false);
const openDialog = ref<string>();

export default () => {
	const route = useRoute();
	const routeQuery = computed(() => route.query.d as LocationQueryValue);

	const handleDialogQuery = (queryValue: LocationQueryValue) => {
		const dialog:
			| DialogNameType
			| LocationQueryValue
			| LocationQueryValue[] = queryValue;

		if (!dialog) {
			openDialog.value = undefined;

			return;
		}

		if (dialog === APPOINTMENT_QUERY) {
			openDialog.value = DIALOG_APPOINTMENT;
		}
	};

	onMounted(() => {
		if (routeQuery.value) {
			handleDialogQuery(routeQuery.value);
		}
	});

	watch(routeQuery, (routeQuery) => {
		handleDialogQuery(routeQuery);
	});

	const openCookieDialog = () => {
		openDialog.value = DIALOG_COOKIE;
	};

	const openAppointmentDialog = () => {
		openDialog.value = DIALOG_APPOINTMENT;
		navigateTo({
			query: {
				...route.query,
				d: APPOINTMENT_QUERY,
			},
		});
	};

	const openContactDialog = () => {
		openDialog.value = DIALOG_CONTACT;
	};

	const openMobileMenu = () => {
		openDialog.value = DIALOG_MOBILE_MENU;
	};

	const closeMobileMenu = () => {
		openDialog.value = undefined;
	};

	const closeDialog = () => {
		openDialog.value = undefined;
		navigateTo({
			query: {
				...route.query,
				d: undefined,
			},
		});

		setHideLogo(false);
		setHideRegularCloseButton(false);
	};

	const setHideRegularCloseButton = (value: boolean) => {
		hideRegularCloseButton.value = value;
	};

	const setHideLogo = (value: boolean) => {
		hideLogo.value = value;
	};

	return {
		isCookieDialogOpen: computed(() => openDialog.value === DIALOG_COOKIE),
		isApplyDialogOpen: computed(
			() => openDialog.value === DIALOG_APPOINTMENT
		),
		isContactDialogOpen: computed(
			() => openDialog.value === DIALOG_CONTACT
		),
		isMobileMenuOpen: computed(
			() => openDialog.value === DIALOG_MOBILE_MENU
		),
		isDialogOpen: computed(() => openDialog.value !== undefined),
		isDialogBottom: computed(() => {
			switch (openDialog.value) {
				case DIALOG_COOKIE:
					return true;
				default:
					return false;
			}
		}),
		closeDialog,
		openCookieDialog,
		openAppointmentDialog,
		openContactDialog,
		openMobileMenu,
		closeMobileMenu,
		hideRegularCloseButton,
		setHideRegularCloseButton,
		hideLogo,
		setHideLogo,
	};
};
